export const starCommandSourceKey = (appId) => `star-command:${encodeURIComponent(appId)}`;
export function starCommandConnected(value, accountKey) {
    return Boolean(value?.enabled && accountKey && value.accountKey === accountKey && value.adapter?.accountKey === accountKey);
}
export function starCommandCurrent(value, accountKey) {
    return starCommandConnected(value, accountKey) && value.fresh && value.snapshot?.accountKey === accountKey;
}
export function selectStarCommandNotices(value, accountKey, filter) {
    if (!starCommandCurrent(value, accountKey) || filter.category === 'question')
        return [];
    const search = filter.search.trim().toLocaleLowerCase();
    return value.snapshot.items.filter(item => (filter.source === 'all' || filter.source === 'star-command' || filter.source === starCommandSourceKey(item.appId))
        && (!filter.unreadOnly || !item.read) && (!search || `${item.title}\n${item.description}\n${item.appName}`.toLocaleLowerCase().includes(search)));
}
export function verifiedStarCommandReceipt(receipt, request) {
    return Boolean(receipt && ['applied', 'pending', 'failed'].includes(receipt.state)
        && receipt.accountKey === request.accountKey && receipt.clientRequestId === request.clientRequestId
        && receipt.noticeId === request.noticeId && receipt.noticeRevision === request.noticeRevision && receipt.appId === request.appId);
}
//# sourceMappingURL=StarCommandPresentation.js.map